<template>
  <SmoothScroll>
    <div class="layout-default">
      <Navbar :isTransparent="isNavbarTransparent" />

      <main class="main-content">
        <slot></slot>
      </main>

      <Footer />
    </div>
  </SmoothScroll>
</template>

<script setup lang="ts">
import Navbar from '../components/globalComponents/Navbar.vue'
import Footer from '../components/globalComponents/Footer.vue'
import SmoothScroll from '../components/globalComponents/SmoothScroll.vue'
import { ref, provide } from 'vue'

const isNavbarTransparent = ref(true)
provide('navbarTransparent', isNavbarTransparent)
</script>

<style scoped>
.layout-default {
  background-color: #161816 !important;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.main-content {
  flex: 1;
  width: 100%;
  position: relative;
}

</style>





